import axios from 'axios';

const API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
const BASE_URL = 'https://maps.googleapis.com/maps/api/place/autocomplete/json';

const waitForGoogleMaps = () => {
  return new Promise((resolve) => {
    const checkGoogleMaps = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        resolve();
      } else {
        setTimeout(checkGoogleMaps, 100);
      }
    };
    checkGoogleMaps();
  });
};

export const searchLocations = async (input) => {
  try {
    await waitForGoogleMaps();

    return new Promise((resolve, reject) => {
      const autocompleteService = new window.google.maps.places.AutocompleteService();
      
      autocompleteService.getPlacePredictions(
        {
          input,
          // Use '(regions)' to incluir cidades e países (regiões administrativas)
          // e remover restrições de país para permitir buscas internacionais
          types: ['(regions)'],
          language: 'pt-BR',
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            resolve(predictions.map((prediction) => ({
              id: prediction.place_id,
              mainText: prediction.structured_formatting.main_text,
              secondaryText: prediction.structured_formatting.secondary_text,
              description: prediction.description,
            })));
          } else {
            resolve([]);
          }
        }
      );
    });
  } catch (error) {
    console.error('Erro ao buscar localizações:', error);
    return [];
  }
};